import { Image, Paper, Text } from "@mantine/core"
import { useRouter } from "next/navigation"
import { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { AppTitle } from "@/components/utils"
import { useAPIResourceAction } from "@/hooks"
import { checkSessionFinished } from "@/types"
import { buildUserSessionURL, usersessionAPI } from "@/utils"
import { ButtonSurvey } from "./StageButton"
import { StageControls } from "./StageControls"
import type { IStageProps } from "./types"

export default function FinishStage(props: IStageProps) {
  const { t } = useTranslation()
  const { onNext, onClose, usersession } = props

  const router = useRouter()
  const hasFinished = useRef(false)
  const finish = useAPIResourceAction(usersessionAPI.url(), usersessionAPI.finish)

  useEffect(() => {
    if (!hasFinished.current) {
      finish.mutate(usersession.id)
      hasFinished.current = true
    }
  }, [usersession.id])

  return (
    <>
      <Paper bg="linear-gradient(135deg, var(--mantine-color-blue-3), var(--mantine-color-blue-9))">
        <Image h={300} alt="Finish" src="https://img.team-tracker.ru/survey/finish.png" />
      </Paper>
      <AppTitle fz={36} lh="40px">
        <Text variant="gradient" gradient={{ from: "pink", to: "yellow" }} inherit>
          {t("Your answers have been sent!")}
        </Text>
      </AppTitle>
      <Text c="dimmed" size="lg">
        {t("Thank you for participating and completing this survey.")}
        <br />
        {t("Your feedback is very valuable and will be taken into account.")}
      </Text>

      <StageControls>
        {!checkSessionFinished(usersession.session) && onNext && (
          <ButtonSurvey variant="navy" onClick={() => onNext()} mx="auto">
            {t("Retake survey")}
          </ButtonSurvey>
        )}
        <ButtonSurvey
          mx="auto"
          variant="navy"
          onClick={() => {
            if (onClose) onClose()
            else router.push(buildUserSessionURL(usersession))
          }}
        >
          {onClose ? t("Close") : t("View answers")}
        </ButtonSurvey>
      </StageControls>
    </>
  )
}
